import { render } from "./IconPhone.vue?vue&type=template&id=4d045906"
import script from "./IconPhone.vue?vue&type=script&lang=js"
export * from "./IconPhone.vue?vue&type=script&lang=js"
script.render = render

export default script